import { render } from "./contactus.vue?vue&type=template&id=7f74f90e"
const script = {}

import exportComponent from "C:\\Users\\abolfazl\\Desktop\\New folder\\vue-tailwind\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__